import { GradientProgressBar } from "@/src/components/GradientProgressBar";
import { ospThemes } from "@ospweb/sdk-ui";
import { I18nUtil } from "@utils/i18n";
import React from "react";
import Translations from "@translate/components/Home/MarketIndicators/AltcoinSeason/AltcoinSeason";
import { cn } from "utils";

const I18n = I18nUtil.createScoped(Translations);

interface AltcoinSeasonProps {
  /** 标题 */
  title?: string;
  /** 当前值 */
  value?: number;
  /** 自定义类名 */
  className?: string;
}

export const AltcoinSeason: React.FC<AltcoinSeasonProps> = ({
  title = I18n.t("Altcoin Season Index"),
  value = 0,
  className,
}) => {
  return (
    <div className={cn("flex flex-col gap-1", className)}>
      {/* 标题 */}
      <h3
        aria-label="Altcoin Season h3"
        data-openreplay-label="Altcoin Season h3 Semantic"
        id="sem-altcoin-season-h3"
        className="title_l text-content_primary"
      >
        {title}
      </h3>
      {/* 数值显示 */}
      <div className="flex items-end gap-1">
        <div className="headline_regular_s text-content_primary">{value}</div>
        <div className="body_m text-content_tertiary">/100</div>
      </div>
      {/* 标签 */}
      <div className="flex justify-between">
        <span className="body_medium_s text-content_tertiary">
          {I18n.t("Bitcoin")}
        </span>
        <span className="body_medium_s text-content_tertiary">
          {I18n.t("Altcoin")}
        </span>
      </div>
      {/* 渐变进度条 */}
      <GradientProgressBar
        value={value}
        startColor={ospThemes.colors.content_accent5_primary}
        endColor={ospThemes.colors.content_aura_lv2_primary}
        className="mt-1"
      />
    </div>
  );
};
